module.exports = __webpack_public_path__ + "img/symbol_4.6a6f1eff.png";